export const countryCodes = [
    {
        "value": "+93",
        "label": "+93 AF"
    },
    {
        "value": "+358-18",
        "label": "+358-18 AX"
    },
    {
        "value": "+355",
        "label": "+355 AL"
    },
    {
        "value": "+213",
        "label": "+213 DZ"
    },
    {
        "value": "+1-684",
        "label": "+1-684 AS"
    },
    {
        "value": "+376",
        "label": "+376 AD"
    },
    {
        "value": "+244",
        "label": "+244 AO"
    },
    {
        "value": "+1-264",
        "label": "+1-264 AI"
    },
    {
        "value": "+",
        "label": "+ AQ"
    },
    {
        "value": "+1-268",
        "label": "+1-268 AG"
    },
    {
        "value": "+54",
        "label": "+54 AR"
    },
    {
        "value": "+374",
        "label": "+374 AM"
    },
    {
        "value": "+297",
        "label": "+297 AW"
    },
    {
        "value": "+61",
        "label": "+61 AU"
    },
    {
        "value": "+43",
        "label": "+43 AT"
    },
    {
        "value": "+994",
        "label": "+994 AZ"
    },
    {
        "value": "+1-242",
        "label": "+1-242 BS"
    },
    {
        "value": "+973",
        "label": "+973 BH"
    },
    {
        "value": "+880",
        "label": "+880 BD"
    },
    {
        "value": "+1-246",
        "label": "+1-246 BB"
    },
    {
        "value": "+375",
        "label": "+375 BY"
    },
    {
        "value": "+32",
        "label": "+32 BE"
    },
    {
        "value": "+501",
        "label": "+501 BZ"
    },
    {
        "value": "+229",
        "label": "+229 BJ"
    },
    {
        "value": "+1-441",
        "label": "+1-441 BM"
    },
    {
        "value": "+975",
        "label": "+975 BT"
    },
    {
        "value": "+58",
        "label": "+58 VE"
    },
    {
        "value": "+591",
        "label": "+591 BO"
    },
    {
        "value": "+599",
        "label": "+599 BQ"
    },
    {
        "value": "+387",
        "label": "+387 BA"
    },
    {
        "value": "+267",
        "label": "+267 BW"
    },
    {
        "value": "+",
        "label": "+ BV"
    },
    {
        "value": "+55",
        "label": "+55 BR"
    },
    {
        "value": "+246",
        "label": "+246 IO"
    },
    {
        "value": "+673",
        "label": "+673 BN"
    },
    {
        "value": "+359",
        "label": "+359 BG"
    },
    {
        "value": "+226",
        "label": "+226 BF"
    },
    {
        "value": "+257",
        "label": "+257 BI"
    },
    {
        "value": "+238",
        "label": "+238 CV"
    },
    {
        "value": "+855",
        "label": "+855 KH"
    },
    {
        "value": "+237",
        "label": "+237 CM"
    },
    {
        "value": "+1",
        "label": "+1 CA"
    },
    {
        "value": "+1-345",
        "label": "+1-345 KY"
    },
    {
        "value": "+236",
        "label": "+236 CF"
    },
    {
        "value": "+235",
        "label": "+235 TD"
    },
    {
        "value": "+56",
        "label": "+56 CL"
    },
    {
        "value": "+86",
        "label": "+86 CN"
    },
    // {
    //     "value": "+61",
    //     "label": "+61 CX"
    // },
    // {
    //     "value": "+61",
    //     "label": "+61 CC"
    // },
    {
        "value": "+57",
        "label": "+57 CO"
    },
    {
        "value": "+269",
        "label": "+269 KM"
    },
    {
        "value": "+242",
        "label": "+242 CG"
    },
    {
        "value": "+243",
        "label": "+243 CD"
    },
    {
        "value": "+682",
        "label": "+682 CK"
    },
    {
        "value": "+506",
        "label": "+506 CR"
    },
    {
        "value": "+225",
        "label": "+225 CI"
    },
    {
        "value": "+385",
        "label": "+385 HR"
    },
    {
        "value": "+53",
        "label": "+53 CU"
    },
    {
        "value": "+599",
        "label": "+599 CW"
    },
    {
        "value": "+357",
        "label": "+357 CY"
    },
    {
        "value": "+420",
        "label": "+420 CZ"
    },
    {
        "value": "+670",
        "label": "+670 TL"
    },
    {
        "value": "+45",
        "label": "+45 DK"
    },
    {
        "value": "+253",
        "label": "+253 DJ"
    },
    {
        "value": "+1-767",
        "label": "+1-767 DM"
    },
    {
        "value": "+1-809 and 1-829",
        "label": "+1-809 and 1-829 DO"
    },
    {
        "value": "+593",
        "label": "+593 EC"
    },
    {
        "value": "+20",
        "label": "+20 EG"
    },
    {
        "value": "+503",
        "label": "+503 SV"
    },
    {
        "value": "+240",
        "label": "+240 GQ"
    },
    {
        "value": "+291",
        "label": "+291 ER"
    },
    {
        "value": "+372",
        "label": "+372 EE"
    },
    {
        "value": "+251",
        "label": "+251 ET"
    },
    {
        "value": "+500",
        "label": "+500 FK"
    },
    {
        "value": "+298",
        "label": "+298 FO"
    },
    {
        "value": "+679",
        "label": "+679 FJ"
    },
    {
        "value": "+358",
        "label": "+358 FI"
    },
    {
        "value": "+33",
        "label": "+33 FR"
    },
    {
        "value": "+594",
        "label": "+594 GF"
    },
    {
        "value": "+689",
        "label": "+689 PF"
    },
    {
        "value": "+",
        "label": "+ TF"
    },
    {
        "value": "+241",
        "label": "+241 GA"
    },
    {
        "value": "+220",
        "label": "+220 GM"
    },
    {
        "value": "+995",
        "label": "+995 GE"
    },
    {
        "value": "+49",
        "label": "+49 DE"
    },
    {
        "value": "+233",
        "label": "+233 GH"
    },
    {
        "value": "+350",
        "label": "+350 GI"
    },
    {
        "value": "+30",
        "label": "+30 GR"
    },
    {
        "value": "+299",
        "label": "+299 GL"
    },
    {
        "value": "+1-473",
        "label": "+1-473 GD"
    },
    {
        "value": "+590",
        "label": "+590 GP"
    },
    {
        "value": "+1-671",
        "label": "+1-671 GU"
    },
    {
        "value": "+502",
        "label": "+502 GT"
    },
    {
        "value": "+44-1481",
        "label": "+44-1481 GG"
    },
    {
        "value": "+224",
        "label": "+224 GN"
    },
    {
        "value": "+245",
        "label": "+245 GW"
    },
    {
        "value": "+592",
        "label": "+592 GY"
    },
    {
        "value": "+509",
        "label": "+509 HT"
    },
    {
        "value": "+ ",
        "label": "+  HM"
    },
    {
        "value": "+504",
        "label": "+504 HN"
    },
    {
        "value": "+852",
        "label": "+852 HK"
    },
    {
        "value": "+36",
        "label": "+36 HU"
    },
    {
        "value": "+354",
        "label": "+354 IS"
    },
    {
        "value": "+91",
        "label": "+91 IN"
    },
    {
        "value": "+62",
        "label": "+62 ID"
    },
    {
        "value": "+98",
        "label": "+98 IR"
    },
    {
        "value": "+964",
        "label": "+964 IQ"
    },
    {
        "value": "+353",
        "label": "+353 IE"
    },
    {
        "value": "+972",
        "label": "+972 IL"
    },
    {
        "value": "+39",
        "label": "+39 IT"
    },
    {
        "value": "+1-876",
        "label": "+1-876 JM"
    },
    {
        "value": "+47",
        "label": "+47 SJ"
    },
    {
        "value": "+81",
        "label": "+81 JP"
    },
    {
        "value": "+44-1534",
        "label": "+44-1534 JE"
    },
    {
        "value": "+962",
        "label": "+962 JO"
    },
    {
        "value": "+7",
        "label": "+7 KZ"
    },
    {
        "value": "+254",
        "label": "+254 KE"
    },
    {
        "value": "+686",
        "label": "+686 KI"
    },
    {
        "value": "+82",
        "label": "+82 KR"
    },
    {
        "value": "+",
        "label": "+ XK"
    },
    {
        "value": "+965",
        "label": "+965 KW"
    },
    {
        "value": "+996",
        "label": "+996 KG"
    },
    {
        "value": "+856",
        "label": "+856 LA"
    },
    {
        "value": "+371",
        "label": "+371 LV"
    },
    {
        "value": "+961",
        "label": "+961 LB"
    },
    {
        "value": "+266",
        "label": "+266 LS"
    },
    {
        "value": "+231",
        "label": "+231 LR"
    },
    {
        "value": "+218",
        "label": "+218 LY"
    },
    {
        "value": "+423",
        "label": "+423 LI"
    },
    {
        "value": "+370",
        "label": "+370 LT"
    },
    {
        "value": "+352",
        "label": "+352 LU"
    },
    {
        "value": "+853",
        "label": "+853 MO"
    },
    {
        "value": "+389",
        "label": "+389 MK"
    },
    {
        "value": "+261",
        "label": "+261 MG"
    },
    {
        "value": "+265",
        "label": "+265 MW"
    },
    {
        "value": "+60",
        "label": "+60 MY"
    },
    {
        "value": "+960",
        "label": "+960 MV"
    },
    {
        "value": "+223",
        "label": "+223 ML"
    },
    {
        "value": "+356",
        "label": "+356 MT"
    },
    {
        "value": "+44-1624",
        "label": "+44-1624 IM"
    },
    {
        "value": "+692",
        "label": "+692 MH"
    },
    {
        "value": "+596",
        "label": "+596 MQ"
    },
    {
        "value": "+222",
        "label": "+222 MR"
    },
    {
        "value": "+230",
        "label": "+230 MU"
    },
    {
        "value": "+262",
        "label": "+262 YT"
    },
    {
        "value": "+52",
        "label": "+52 MX"
    },
    {
        "value": "+691",
        "label": "+691 FM"
    },
    {
        "value": "+373",
        "label": "+373 MD"
    },
    {
        "value": "+377",
        "label": "+377 MC"
    },
    {
        "value": "+976",
        "label": "+976 MN"
    },
    {
        "value": "+382",
        "label": "+382 ME"
    },
    {
        "value": "+1-664",
        "label": "+1-664 MS"
    },
    {
        "value": "+212",
        "label": "+212 MA"
    },
    {
        "value": "+258",
        "label": "+258 MZ"
    },
    {
        "value": "+95",
        "label": "+95 MM"
    },
    {
        "value": "+264",
        "label": "+264 NA"
    },
    {
        "value": "+674",
        "label": "+674 NR"
    },
    {
        "value": "+977",
        "label": "+977 NP"
    },
    {
        "value": "+31",
        "label": "+31 NL"
    },
    {
        "value": "+687",
        "label": "+687 NC"
    },
    {
        "value": "+64",
        "label": "+64 NZ"
    },
    {
        "value": "+505",
        "label": "+505 NI"
    },
    {
        "value": "+227",
        "label": "+227 NE"
    },
    {
        "value": "+234",
        "label": "+234 NG"
    },
    {
        "value": "+683",
        "label": "+683 NU"
    },
    {
        "value": "+672",
        "label": "+672 NF"
    },
    {
        "value": "+850",
        "label": "+850 KP"
    },
    {
        "value": "+1-670",
        "label": "+1-670 MP"
    },
    {
        "value": "+47",
        "label": "+47 NO"
    },
    {
        "value": "+968",
        "label": "+968 OM"
    },
    {
        "value": "+92",
        "label": "+92 PK"
    },
    {
        "value": "+680",
        "label": "+680 PW"
    },
    {
        "value": "+970",
        "label": "+970 PS"
    },
    {
        "value": "+507",
        "label": "+507 PA"
    },
    {
        "value": "+675",
        "label": "+675 PG"
    },
    {
        "value": "+595",
        "label": "+595 PY"
    },
    {
        "value": "+51",
        "label": "+51 PE"
    },
    {
        "value": "+63",
        "label": "+63 PH"
    },
    {
        "value": "+870",
        "label": "+870 PN"
    },
    {
        "value": "+48",
        "label": "+48 PL"
    },
    {
        "value": "+351",
        "label": "+351 PT"
    },
    {
        "value": "+1-787 and 1-939",
        "label": "+1-787 and 1-939 PR"
    },
    {
        "value": "+974",
        "label": "+974 QA"
    },
    {
        "value": "+262",
        "label": "+262 RE"
    },
    {
        "value": "+40",
        "label": "+40 RO"
    },
    {
        "value": "+7",
        "label": "+7 RU"
    },
    {
        "value": "+250",
        "label": "+250 RW"
    },
    {
        "value": "+590",
        "label": "+590 BL"
    },
    {
        "value": "+290",
        "label": "+290 SH"
    },
    {
        "value": "+1-869",
        "label": "+1-869 KN"
    },
    {
        "value": "+1-758",
        "label": "+1-758 LC"
    },
    {
        "value": "+590",
        "label": "+590 MF"
    },
    {
        "value": "+508",
        "label": "+508 PM"
    },
    {
        "value": "+1-784",
        "label": "+1-784 VC"
    },
    {
        "value": "+685",
        "label": "+685 WS"
    },
    {
        "value": "+378",
        "label": "+378 SM"
    },
    {
        "value": "+239",
        "label": "+239 ST"
    },
    {
        "value": "+966",
        "label": "+966 SA"
    },
    {
        "value": "+221",
        "label": "+221 SN"
    },
    {
        "value": "+381",
        "label": "+381 RS"
    },
    {
        "value": "+248",
        "label": "+248 SC"
    },
    {
        "value": "+232",
        "label": "+232 SL"
    },
    {
        "value": "+65",
        "label": "+65 SG"
    },
    {
        "value": "+599",
        "label": "+599 SX"
    },
    {
        "value": "+421",
        "label": "+421 SK"
    },
    {
        "value": "+386",
        "label": "+386 SI"
    },
    {
        "value": "+677",
        "label": "+677 SB"
    },
    {
        "value": "+252",
        "label": "+252 SO"
    },
    {
        "value": "+27",
        "label": "+27 ZA"
    },
    {
        "value": "+",
        "label": "+ GS"
    },
    {
        "value": "+211",
        "label": "+211 SS"
    },
    {
        "value": "+34",
        "label": "+34 ES"
    },
    {
        "value": "+94",
        "label": "+94 LK"
    },
    {
        "value": "+249",
        "label": "+249 SD"
    },
    {
        "value": "+597",
        "label": "+597 SR"
    },
    {
        "value": "+47",
        "label": "+47 SJ"
    },
    {
        "value": "+268",
        "label": "+268 SZ"
    },
    {
        "value": "+46",
        "label": "+46 SE"
    },
    {
        "value": "+41",
        "label": "+41 CH"
    },
    {
        "value": "+963",
        "label": "+963 SY"
    },
    {
        "value": "+886",
        "label": "+886 TW"
    },
    {
        "value": "+992",
        "label": "+992 TJ"
    },
    {
        "value": "+255",
        "label": "+255 TZ"
    },
    {
        "value": "+66",
        "label": "+66 TH"
    },
    {
        "value": "+228",
        "label": "+228 TG"
    },
    {
        "value": "+690",
        "label": "+690 TK"
    },
    {
        "value": "+676",
        "label": "+676 TO"
    },
    {
        "value": "+1-868",
        "label": "+1-868 TT"
    },
    {
        "value": "+216",
        "label": "+216 TN"
    },
    {
        "value": "+90",
        "label": "+90 TR"
    },
    {
        "value": "+993",
        "label": "+993 TM"
    },
    {
        "value": "+1-649",
        "label": "+1-649 TC"
    },
    {
        "value": "+688",
        "label": "+688 TV"
    },
    {
        "value": "+1",
        "label": "+1 UM"
    },
    {
        "value": "+256",
        "label": "+256 UG"
    },
    {
        "value": "+380",
        "label": "+380 UA"
    },
    {
        "value": "+971",
        "label": "+971 AE"
    },
    {
        "value": "+44",
        "label": "+44 GB"
    },
    {
        "value": "+1",
        "label": "+1 US"
    },
    {
        "value": "+598",
        "label": "+598 UY"
    },
    {
        "value": "+998",
        "label": "+998 UZ"
    },
    {
        "value": "+678",
        "label": "+678 VU"
    },
    {
        "value": "+379",
        "label": "+379 VA"
    },
    {
        "value": "+84",
        "label": "+84 VN"
    },
    {
        "value": "+1-340",
        "label": "+1-340 VI"
    },
    {
        "value": "+1-284",
        "label": "+1-284 VG"
    },
    {
        "value": "+681",
        "label": "+681 WF"
    },
    {
        "value": "+967",
        "label": "+967 YE"
    },
    {
        "value": "+260",
        "label": "+260 ZM"
    },
    {
        "value": "+263",
        "label": "+263 ZW"
    }
]